class OptionsManager {
    constructor(configuratorId) {
        this.options = {};
        this.configurator = $('body .pc-configurator-popup[data-configurator-id="' + configuratorId + '"]');
        if (!this.configurator.length) {
            console.error('Configurator not found:', configuratorId);
            return;
        }
        
        this.initOptions();
    }

    initOptions() {
        // Size Option
        if (this.configurator.find('.pc-option-size').length) {
            const $sizeOptions = this.configurator.find('.pc-option-size');
            $sizeOptions.each((index, option) => {
                this.options.size = new SizeOption($(option));
            });
        }
        
        // Icon Text Option
        if (this.configurator.find('.pc-option-icon_text').length) {
            const $iconTextOptions = this.configurator.find('.pc-option-icon_text');
            $iconTextOptions.each((index, option) => {
                this.options.iconText = new IconTextOption($(option));
            });
        }

        // Image Text Option
        if (this.configurator.find('.pc-option-image_text').length) {
            const $imageTextOptions = this.configurator.find('.pc-option-image_text');
            $imageTextOptions.each((index, option) => {
                this.options.imageText = new ImageTextOption($(option));
            });
        }

        // Gallery Option
        if (this.configurator.find('.pc-option-gallery').length) {
            const $galleryOptions = this.configurator.find('.pc-option-gallery');
            $galleryOptions.each((index, option) => {
                this.options.gallery = new GalleryOption($(option));
            });
        }

        // Pitch Print Option
        if (this.configurator.find('.pc-option-pitch_print').length) {
            const $pitchPrintOptions = this.configurator.find('.pc-option-pitch_print');
            $pitchPrintOptions.each((index, option) => {
                this.options.pitchPrint = new PitchPrintOption($(option));
            });
        }

        // User Input Option
        if (this.configurator.find('.pc-option-user_input').length) {
            const $userInputOptions = this.configurator.find('.pc-option-user_input');
            $userInputOptions.each((index, option) => {
                this.options.userInput = new UserInputOption($(option));
            });
        }
    }
} 